import { useEffect } from "react";

import { MainPageTabs } from "@/enum/common";
import useCheckMobileScreen from "@/hooks/useCheckMobileScreen";
import { useFilters } from "@/providers/FiltersProvider";
import { ITabsData } from "@/types/Filters";

const tabsData: ITabsData[] = [
    {
        label: "Locations",
        value: MainPageTabs.regions,
    },
    {
        label: "Sectors",
        value: MainPageTabs.sectors,
    },
    {
        label: "Generations",
        value: MainPageTabs.generations,
    },
    {
        label: "Investment",
        value: MainPageTabs.investment,
    },
];

interface IUseExploreMobileView {
    setTabsListData: React.Dispatch<React.SetStateAction<ITabsData[]>>;
}
function useExploreMobileView({
    setTabsListData,
}: IUseExploreMobileView) {
    const { setSelectedTab } = useFilters();
    const isMobile = useCheckMobileScreen();
    useEffect(() => {
        if (!isMobile) {
            setTabsListData(tabsData);
            setSelectedTab(MainPageTabs.regions);
            return;
        }
        setTabsListData([
            {
                label: "Summary",
                value: MainPageTabs.summary,
            },
            ...tabsData,
        ]);
        setSelectedTab(MainPageTabs.summary);
    }, [isMobile]);
}

export default useExploreMobileView;
